import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isRegister:false,//是否是注册页面 1不是 2是
    isHome:true,//是否是首页
    isMyCourse:true,//是否是我的课程
    knowledge:'',//当前视频知识点
    studentId:'',//学生id
    qrcode:'',//激活班级
    mobile:'',//手机
    Authorization:'',//token
    openid:'oQlP0t7F0sdgCC1i5-gOHQhovihs',//openid
  },
  mutations: {

  },
  actions: {

  }
})
